import * as Tgcc from '../tgccGlobal'
import * as React from 'react'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'

class CatProps extends Tgcc.BaseProps {
    category: Tgcc.ProductCategory;
    selected: boolean;
    onChange?: (category: Tgcc.ProductCategory) => void;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    width: '150px',
    margin: '2px 8px',
    overflow: 'hidden',
    cursor: 'pointer',
    height: '24px',
    lineHeight: '22px'
};

const catStyle: CSSProperties = {
    fontFamily:'CenturyGothic',
    fontSize: '13px',
    letterSpacing: '1px',
    fontWeight: "bold",
    whiteSpace: 'nowrap',
    textAlign: 'left',
    padding: '1px 5px',
    backgroundColor: 'transparent'
};
let catStyleSelect = Object.assign({}, catStyle, {backgroundColor: Tgcc.Styles.grayHighlight});
    
export class _ProductCategory extends React.Component<CatProps, any> {
    state = {
        selected: false 
    }

    changeFilter = (category: Tgcc.ProductCategory) => {
        if(this.props.onChange)
            this.props.onChange(category)
        this.props.dispatch({type: Tgcc.StateAction.FilterProductsByCategory, payload: category})
    } 

    render() {
        var cStyle = this.props.selected ? catStyleSelect : catStyle;
        
        return (
            <div style={wrapperStyle}>
                <div style={cStyle} onClick={this.doFilter}>{this.props.category.category}</div>
            </div>
        )
    }

    doFilter = () => {
        // clear the existing filter if it matches
        if(this.props.selected)
            this.changeFilter(null);
        else 
            this.changeFilter(this.props.category)
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    if(state && state.FilterProductsByCategory)
        return { selected: ownState.category.Id == state.FilterProductsByCategory.id };
    return {selected: false};
};
export var ProductCategory = connect(mapStateToProps)(_ProductCategory);

